module.exports = __webpack_public_path__ + "media/images/swiss/confirmation/confirmation-image-e9b76cd355990859d54adc91b99377dd.png";